/**
 * 存储
 */
export const setStore = (name, content) => {
  UpSDK.cache.setCache(name, content);
};

/**
 * 获取
 */
export const getStore = name => {
  return UpSDK.cache.getCache(name);
};

/**
 * 删除
 */
export const removeStore = name => {
  UpSDK.cache.removeCache(name);
};



// WEBPACK FOOTER //
// ./src/js/mUtils.js